"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DetectableOverflow_1 = require("./DetectableOverflow");
exports.default = DetectableOverflow_1.DetectableOverflow;
//# sourceMappingURL=index.js.map